export default __webpack_public_path__ + "static/forms_compare_comp1_inactive-1b3c546388d57ce5c66bb4f4520c6a98.png";